import React from "react";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import styled from "@emotion/styled";
import pxToRem from "assets/theme/functions/pxToRem";

const CustomLinearProgress = styled(LinearProgress)({
  height: pxToRem(3),
  borderRadius: 0,
  overflow: "hidden",
});

export default function PopupLinearProgress() {
  return (
    <Box sx={{ width: "100%" }} overflow={"hidden"}>
      <CustomLinearProgress color="info" />
    </Box>
  );
}
